import moment from 'moment'
import type { IntlShape } from 'react-intl'
import { INTL_DATE_TIME_FORMAT } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'

const deadlineFormat = { ...INTL_DATE_TIME_FORMAT, timeZoneName: 'short' } satisfies Intl.DateTimeFormatOptions

export function getScheduleChangeAirlineName(change: App.FlightScheduleChange, intl: IntlShape): string {
  return change.newLegs.find(leg => leg.id === change.affectedLegs[0]?.newLegId)?.flights[0]?.marketingAirline.name ?? intl.formatMessage({
    id: 'duUUupQLmU5Liux_lpl9',
    defaultMessage: 'Your airline',
    description: 'Fallback airline name used in the flight schedule change review banner when no name is supplied',
  })
}

export function formatScheduleChangeDeadline(change: App.FlightScheduleChange, locale: string): string {
  return intlDateFormatter(change.respondBy, deadlineFormat, locale, 'Australia/Sydney')
}

export function parseScheduleChangeDateTime(value: string) {
  return moment.utc(value, 'DD/MM/YYYY-HH:mm', true)
}

export function toScheduleChangeDateTime(date: string, time: string): string {
  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}-${time}`
}

export function getScheduleChangeStopDateTime(stop: App.FlightScheduleChangeHiddenStop, event: 'arrival' | 'departure'): string | undefined {
  const date = event === 'arrival' ? stop.arrivalDate : stop.departureDate
  const time = event === 'arrival' ? stop.arrivalTime : stop.departureTime
  if (!date || !time || !moment.utc(`${date}T${time}`, ['YYYY-MM-DDTHH:mm', 'YYYY-MM-DDTHH:mm:ss'], true).isValid()) return undefined
  return toScheduleChangeDateTime(date, time.slice(0, 5))
}
